import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { DatePickerConsumeFeature, DatePickerFeature } from '@app/src/common/datePicker';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { isClientEnv } from '@app/src/utils/validations';
import { Wrapper } from './styled';
import { TypePublicationModel } from '@app/src/views/StepTwo/channelPublication';

const isClient = isClientEnv();

export const AnnouncementCalendar: React.FC = () => {
  const history = useHistory();
  const { packageId } = useParams();

  const printStorage = isClient && JSON.parse(sessionStorage.getItem('print'));
  const categoryConfig = CATEGORIES[CATEGORY[printStorage && printStorage.general && printStorage.general.category]];

  const category = useSelector(state => state.print.general.category);
  const currentChannel: TypePublicationModel = useSelector(state => state.typePublication.selected);
  const extracharges = useSelector(state => state.extracharge.data[currentChannel && currentChannel.id]);
  const typeUserAction = useSelector(state => state.session.user.pasarella);

  useEffect(() => {
    if (!currentChannel) {
      if (typeUserAction === 'consume-print') {
        history.push(`${categoryConfig.paths.consumePackage.stepTypePublication}/${packageId}`);
      } else if (typeUserAction === 'purchase-print') {
        history.push(categoryConfig.paths.purchasePrint.stepTypePublication);
      } else {
        history.goBack();
      }
    }
  }, []);

  const handleClickBack = () => {
    setTimeout(() => {
      if (typeUserAction === 'consume-print') {
        history.push(`${categoryConfig.paths.consumePackage.stepTypePublication}/${packageId}`);
      }
      if (typeUserAction === 'purchase-print') {
        history.push(categoryConfig.paths.purchasePrint.stepTypePublication);
      }
    }, 500);
  };

  const handleClickNext = (data: any) => {
    setConfigForDatalayer(data.printDate);
    setTimeout(() => {
      if (typeUserAction === 'consume-print') {
        history.push(`${categoryConfig.paths.consumePackage.stepExtracharge}/${packageId}`);
      }
      if (typeUserAction === 'purchase-print') {
        history.push(categoryConfig.paths.purchasePrint.stepExtracharge);
      }
    }, 500);
  };

  const setConfigForDatalayer = (datesSelecteds) => {
    if (datesSelecteds && datesSelecteds.length > 0) {
      const dates = datesSelecteds.map(item => `${getZeroFormatDate(item.dayMonth)}-${getZeroFormatDate(item.month + 1)}-${item.year}`);
      pushDatalayerDates(`Paso 2.b - ${categoryConfig.name}`, dates);
      const extrachargesName = formatExtracharges();
      if (extrachargesName && extrachargesName.length > 0) {
        pushDatalayerDates(`Paso 2.c - ${categoryConfig.name}`, extrachargesName);
      }
    }
  };

  const getZeroFormatDate = (date: number) => {
    if (date <= 9) {
      return `0${date}`;
    }
    return date;
  };

  const pushDatalayerDates = (eventAction: string, names: string[]) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Posting',
        'eventAction': eventAction,
        'eventLabel': names.join('|'),
        'eventValue': 1
      });
    }
  };

  const formatExtracharges = () => extracharges && extracharges.data && extracharges.data.length > 0 && extracharges.data.filter(item => item.checked).map(item => item.name);

  return (
    <Wrapper>
      {
        (typeUserAction === 'consume-print') ?
          <DatePickerConsumeFeature
            title="Clasificados El Comercio - Domingo"
            priceAside={50}
            open={true}
            handleClickBack={handleClickBack}
            handleClickNext={handleClickNext}
            categoryId={category}
          />
          :
          <DatePickerFeature
            title="Clasificados El Comercio - Domingo"
            priceAside={50}
            open={true}
            handleClickBack={handleClickBack}
            handleClickNext={handleClickNext}
            categoryId={category}
          />
      }
    </Wrapper>
  )
};